import React from "react";
import ProductDetail from "./ProductDetail";
import { products } from "../data/products";

const ColorLaserJetPage = () => (
  <ProductDetail product={products.colorLaserJet} />
);

export default ColorLaserJetPage;
